(function() {
  var StepController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepController = App.loadClass('grower::Angular/Data/PlantingRx/StepController');

  exports.PrescriptionController = (function(superClass) {
    extend(PrescriptionController, superClass);

    function PrescriptionController(scope, transitions, map, state, rxLayer, visualLayers, layerManager, loader, legend) {
      var i, load_msg, recalc, recolor, results, target_promise;
      this.scope = scope;
      this.transitions = transitions;
      this.map = map;
      this.state = state;
      this.rxLayer = rxLayer;
      this.visualLayers = visualLayers;
      this.layerManager = layerManager;
      this.loader = loader;
      this.legend = legend;
      this.calculateSummaries = bind(this.calculateSummaries, this);
      this.toggleTable = bind(this.toggleTable, this);
      this.checkPopDiffMinMax = bind(this.checkPopDiffMinMax, this);
      this.checkPopMinMax = bind(this.checkPopMinMax, this);
      this.needsRecalc = bind(this.needsRecalc, this);
      this.setPopulationsFromGeom = bind(this.setPopulationsFromGeom, this);
      this.recalculate = bind(this.recalculate, this);
      this.getVisualLayersList = bind(this.getVisualLayersList, this);
      PrescriptionController.__super__.constructor.call(this, this.scope, this.transitions, this.map);
      if (this.scope.aborted) {
        return;
      }
      this.scope.initializing = true;
      this.scope.options_changed = false;
      this.scope.recalculate = this.recalculate;
      this.scope.averagePop = this.rxLayer.averagePop;
      this.scope.toggleTable = this.toggleTable;
      this.scope.checkPopMinMax = this.checkPopMinMax;
      this.scope.checkPopDiffMinMax = this.checkPopDiffMinMax;
      this.scope.legend_rows = [];
      this.scope.event = 'rendered';
      this.scope.can_recalc = true;
      this.scope.recalc_error = null;
      this.scope.recalc_error_type = null;
      this.scope.options = {
        pop_diffs: [100, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000],
        num_pops: (function() {
          results = [];
          for (i = 2; i <= 30; i++){ results.push(i); }
          return results;
        }).apply(this)
      };
      recalc = this.needsRecalc();
      if ((this.scope.rx.solver_variables.target == null) || recalc.recalculate) {
        load_msg = this.loader.overMapAndSidebar('Calculating Target Population...');
        target_promise = this.rxLayer.calculateTargetPop();
        target_promise.then((function(_this) {
          return function(response) {
            var msg, ref;
            load_msg.hide();
            if (((ref = response.status) != null ? ref.type : void 0) === 'error') {
              msg = "Failed to calculate Target Pop: " + response.status.msg;
              _this.scope.recalc_error = msg;
              return _this.scope.recalc_error_type = 'error';
            }
          };
        })(this))["catch"]((function(_this) {
          return function() {
            _this.scope.recalc_error = 'Failed to calculate Target Pop';
            return _this.scope.recalc_error_type = 'error';
          };
        })(this));
      }
      this.getVisualLayersList();
      this.scope.$watch('rx.solver_variables', (function(_this) {
        return function() {
          if (!_this.scope.initializing) {
            return _this.scope.options_changed = true;
          }
        };
      })(this), true);
      this.scope.$watch('rx.populations', (function(_this) {
        return function(val) {
          if (!val || val.length === 0) {
            return _this.scope.$parent.setValidity(false);
          } else if (!_this.scope.rxForm.$invalid) {
            return _this.scope.$parent.setValidity(true);
          }
        };
      })(this));
      recolor = (function(_this) {
        return function() {
          var j, len, polys, ref, results1, strip;
          if (_this.popMapLayer != null) {
            _this.popMapLayer.recolor();
          }
          ref = _this.scope.rx.truth_strips;
          results1 = [];
          for (j = 0, len = ref.length; j < len; j++) {
            strip = ref[j];
            polys = _this.rxLayer.getStripPolygons(strip);
            if (!polys || polys.length === 0) {
              continue;
            }
            results1.push(strip.fillColor = polys[0].fillColor);
          }
          return results1;
        };
      })(this);
      this.scope.$watch('rx.populations', (function(_this) {
        return function() {
          recolor();
          return _this.calculateSummaries();
        };
      })(this), true);
      this.setUpMap();
      if (recalc.fetch) {
        if (target_promise != null) {
          target_promise.then((function(_this) {
            return function(response) {
              var ref;
              if (((ref = response.status) != null ? ref.type : void 0) !== 'error') {
                return _this.recalculate(recalc.recalculate);
              }
            };
          })(this));
        } else {
          this.recalculate(recalc.recalculate);
        }
      } else {
        this.mapLayer.addLayer(this.scope.rx.populations_geom);
        this.setPopulationsFromGeom(this.scope.rx.populations_geom);
        this.scope.initializing = false;
      }
      this.scope.$watch('rxForm.$invalid', (function(_this) {
        return function(val) {
          _this.scope.can_recalc = !val;
          return _this.scope.$parent.setValidity(!val);
        };
      })(this));
    }

    PrescriptionController.prototype.getVisualLayersList = function() {
      var i, layer, layers, len, ref;
      layers = [];
      ref = this.scope.rx.visual_layers;
      for (i = 0, len = ref.length; i < len; i++) {
        layer = ref[i];
        layers.push(layer.name);
      }
      return this.scope.visual_layers_list = layers.join(', ');
    };

    PrescriptionController.prototype.recalculate = function(recalculate) {
      var calculating, load_msg, options;
      if (recalculate == null) {
        recalculate = true;
      }
      options = this.rxLayer.asSolverOptions();
      if (!recalculate) {
        options.recalculate = false;
      }
      calculating = this.scope.rx.populations.length > 0 ? 'Recalculating' : 'Calculating';
      load_msg = this.loader.overMapAndSidebar(calculating + "...");
      this.scope.options_changed = false;
      this.scope.recalc_error = null;
      this.scope.recalc_error_type = null;
      this.mapLayer.clearLayers();
      this.popMapLayer = this.layerManager.get('PopulationMap');
      return this.popMapLayer.display(options, this.mapLayer).then((function(_this) {
        return function(response) {
          _this.setPopulationsFromGeom(response);
          _this.scope.rx.previous_calculation = options;
          _this.scope.initializing = false;
          return load_msg.hide();
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          var ref, ref1;
          _this.scope.initializing = false;
          _this.scope.options_changed = true;
          _this.scope.rx.populations_geom = null;
          _this.scope.rx.populations = [];
          _this.scope.recalc_error = (ref = response.data.status) != null ? ref.msg : void 0;
          _this.scope.recalc_error_type = (ref1 = response.data.status) != null ? ref1.type : void 0;
          return load_msg.hide();
        };
      })(this));
    };

    PrescriptionController.prototype.setPopulationsFromGeom = function(response) {
      var feat, i, len, props, ref, results;
      this.scope.rx.populations_geom = response;
      this.scope.rx.populations = [];
      ref = response.getLayers();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        feat = ref[i];
        props = feat.feature.properties;
        props.temp_population = props.population;
        props.orig_population = parseInt(props.population);
        props.temp_hybrids_id = props.hybrids_id;
        props.temp_hybrid_name = props.hybrid_name;
        results.push(this.scope.rx.populations.push(props));
      }
      return results;
    };

    PrescriptionController.prototype.needsRecalc = function() {
      var comparison, fetch, recalculate, ref;
      fetch = false;
      recalculate = true;
      if (!((ref = this.scope.rx.populations) != null ? ref.length : void 0)) {
        fetch = true;
      }
      comparison = this.rxLayer.compareSolverOptions(this.scope.rx.previous_calculation);
      if (comparison) {
        recalculate = false;
      } else {
        fetch = true;
      }
      return {
        fetch: fetch,
        recalculate: recalculate
      };
    };

    PrescriptionController.prototype.checkPopMinMax = function(set_low) {
      var max, min;
      if (set_low == null) {
        set_low = true;
      }
      min = parseInt(this.scope.rx.solver_variables.min_pop);
      max = parseInt(this.scope.rx.solver_variables.max_pop);
      if (min > max) {
        if (set_low) {
          return this.scope.rx.solver_variables.min_pop = max - 1;
        } else {
          return this.scope.rx.solver_variables.max_pop = min + 1;
        }
      }
    };

    PrescriptionController.prototype.checkPopDiffMinMax = function(set_low) {
      var ind, max, max_ind, min, min_ind, pdiffs;
      if (set_low == null) {
        set_low = true;
      }
      min = parseInt(this.scope.rx.solver_variables.min_pop_diff);
      max = parseInt(this.scope.rx.solver_variables.max_pop_diff);
      pdiffs = this.scope.options.pop_diffs;
      if (min > max) {
        if (set_low) {
          ind = pdiffs.indexOf(max);
          if (ind === 0) {
            min_ind = 0;
          } else {
            min_ind = ind - 1;
          }
          return this.scope.rx.solver_variables.min_pop_diff = pdiffs[min_ind];
        } else {
          ind = pdiffs.indexOf(min);
          if (ind === (pdiffs.length - 1)) {
            max_ind = ind;
          } else {
            max_ind = ind + 1;
          }
          return this.scope.rx.solver_variables.max_pop_diff = pdiffs[max_ind];
        }
      }
    };

    PrescriptionController.prototype.toggleTable = function() {
      this.scope.$parent.show_fullpage = !this.scope.$parent.show_fullpage;
      if (this.scope.$parent.show_fullpage) {
        return this.state.go('grower.planting-rx.prescription.table', null, {
          location: false
        });
      } else {
        return this.state.go('grower.planting-rx.prescription', null, {
          location: false
        });
      }
    };

    PrescriptionController.prototype.calculateSummaries = function() {
      var ac, acres, active_selections, area_sub, avg, i, j, k, l, len, len1, len2, len3, len4, len5, m, mypops, myseeds, n, perc, poly, polys, pop, ref, ref1, ref2, ref3, ref4, ref_pct, refuge, seeds, sel, selection, strip, total_acres;
      total_acres = 0;
      ref_pct = null;
      active_selections = [];
      ref = this.scope.rx.planting_selections;
      for (i = 0, len = ref.length; i < len; i++) {
        sel = ref[i];
        if (sel.active) {
          active_selections.push(sel);
        }
      }
      for (j = 0, len1 = active_selections.length; j < len1; j++) {
        selection = active_selections[j];
        mypops = _.filter(this.scope.rx.populations, {
          temp_hybrids_id: selection.brand.id
        });
        seeds = 0;
        acres = 0;
        for (k = 0, len2 = mypops.length; k < len2; k++) {
          pop = mypops[k];
          ac = parseFloat(pop.acres);
          myseeds = pop.temp_population * ac;
          seeds += myseeds;
          acres += ac;
          pop.units = (myseeds / this.scope.rx.seeds_per_bag).toFixed(1);
        }
        total_acres += acres;
        if (selection.primary && ((ref1 = this.scope.rx.refuge) != null ? ref1.active : void 0)) {
          ref_pct = (ref2 = selection.brand.ref_pct) != null ? ref2 : 20;
          if (active_selections.length === 1) {
            area_sub = (ref_pct * 0.5) / 100;
            acres = acres - (acres * area_sub);
          }
        }
        if (seeds > 0) {
          acres = acres.toFixed(1);
          avg = Math.round(seeds / acres);
        } else {
          avg = 0;
        }
        selection.units = Math.ceil(seeds / this.scope.rx.seeds_per_bag);
        selection.acres = acres;
        selection.avg_pop = avg;
      }
      ref3 = this.scope.rx.truth_strips;
      for (l = 0, len3 = ref3.length; l < len3; l++) {
        strip = ref3[l];
        strip.units = 0;
        polys = this.rxLayer.getStripPolygons(strip);
        if (!polys || polys.length === 0) {
          continue;
        }
        for (m = 0, len4 = polys.length; m < len4; m++) {
          poly = polys[m];
          strip.units += parseFloat(poly.units);
        }
        strip.units = strip.units.toFixed(1);
      }
      for (n = 0, len5 = active_selections.length; n < len5; n++) {
        selection = active_selections[n];
        perc = (selection.acres / total_acres) * 100;
        selection.perc_acres = perc.toFixed(1);
      }
      if ((ref4 = this.scope.rx.refuge) != null ? ref4.active : void 0) {
        refuge = this.scope.rx.refuge;
        refuge.acres = (total_acres * (ref_pct / 100)).toFixed(1);
        refuge.perc_acres = ref_pct;
        refuge.avg_pop = this.scope.averagePop();
        return refuge.units = Math.ceil((refuge.avg_pop * refuge.acres) / this.scope.rx.seeds_per_bag);
      }
    };

    return PrescriptionController;

  })(StepController);

}).call(this);
